export const translations = {
  fr: {
    common: {
      or: 'ou',
      discover_service: 'Découvrir le service',
      previous: 'Précédent',
      next: 'Suivant',
      go_to: 'Aller à {{title}}'
    },
    header: {
      language_label: 'Changer de langue',
      account: 'Compte',
      account_aria: 'Ouvrir l’espace étudiant',
      logout: 'Sortir',
      menu_open: 'Ouvrir le menu',
      menu_close: 'Fermer le menu'
    },
    nav: {
      home: 'Accueil',
      services: 'Services',
      courses: 'Cours',
      about: 'À propos',
      contact: 'Contact',
      quote: 'Devis',
      login: 'Connexion'
    },
    mega: {
      categories: {
        traductions: {
          label: 'TRADUCTIONS',
          description: 'Légal, finance, technique, médical',
          items: {
            legal: 'Traductions légales & assermentées',
            commercial: 'Traductions commerciales',
            financial: 'Traductions économico-financières',
            technical: 'Traductions techniques',
            medical: 'Traductions médico-pharmaceutiques',
            literary: 'Traductions littéraires'
          }
        },
        interpretariat: {
          label: 'INTERPRÉTARIAT',
          description: 'Simultané, consécutif, missions diplomatiques',
          items: {
            consecutive: 'Interprétariat consécutif',
            liaison: 'Interprétariat de liaison',
            simultaneous: 'Interprétariat simultané',
            whispering: 'Interprétariat chuchotage'
          }
        },
        assistance: {
          label: 'ASSISTANCE LINGUISTIQUE',
          description: 'Support juridique, hotline multilingue, médiation',
          items: {
            legal: 'Pratiques légales et notariales',
            hotline: 'Assistance linguistique téléphonique',
            hostess: 'Service hostess & accueil',
            assessment: 'Évaluation linguistique du personnel',
            mediation: 'Médiation culturelle',
            business: 'Forfait business intégré'
          }
        },
        cours: {
          label: 'COURS DE LANGUES',
          description: 'Formations pro, examens, coaching sectoriel',
          items: {
            general: 'Cours de langue générale',
            business: 'Cours pour entreprises',
            one_to_one: 'Cours particuliers (one-to-one)',
            exams: 'Préparation aux examens',
            sector: 'Cours spécialisés par secteur'
          }
        },
        planimetrie: {
          label: 'PLANIMÉTRIE',
          description: 'Plans urbains, topographie, cadastre',
          items: {
            urbanism: "Plans d'urbanisme",
            architectural: 'Plans architecturaux',
            topo: 'Cartes topographiques',
            cadastral: 'Plans cadastraux'
          }
        },
        evenementiel: {
          label: 'ÉVÉNEMENTIEL',
          description: 'Conférences, séminaires, lancements produits',
          items: {
            conferences: 'Organisation de conférences',
            seminars: 'Séminaires internationaux',
            launches: 'Lancements de produits',
            congresses: 'Congrès multilingues'
          }
        }
      },
      cta: {
        eyebrow: 'Accélérer vos projets',
        title: 'Devis en 24h',
        description: 'Parlez à un chargé de compte dédié pour dimensionner l’équipe {{companyName}}.',
        button: 'Demander un devis'
      }
    },
    services: {
      interpretation: 'Interprétariat',
      translation: 'Traduction',
      admin_assistance: 'Assistance administrative',
      language_courses: 'Cours de langues',
      planimetry: 'Planimétrie',
      events: 'Événementiel',
      accents: {
        interpretariat: 'Simultané / consécutif',
        traduction: 'Certifiées & express',
        'assistance-administrative': 'Due diligence & back-office',
        'cours-langues': 'Blended learning',
        planimetrie: 'Projection & scénographie',
        evenementiel: 'Direction de production'
      },
      explore: 'Explorer →',
      desc_interpretariat: 'Interprètes trilingues, missions diplomatiques, simultané et consécutif.',
      desc_traduction: 'Traductions certifiées et relecture double pour dossiers sensibles.',
      'desc_assistance-administrative': 'Back-office, médiation culturelle et assistance administrative premium.',
      'desc_cours-langues': 'Formations sur mesure, coaching et préparation aux examens.',
      desc_planimetrie: 'Plans, topographie et dossiers techniques avec contrôle qualité.',
      desc_evenementiel: 'Production, staffing et coordination multilingue pour vos événements.'
    },
    buttons: {
      request_service: 'Demander ce service',
      view_prices: 'Voir les tarifs',
      send: 'Envoyer',
      sending: 'Envoi...',
      send_request: 'Envoyer la demande'
    },
    services_page: {
      seo_title: 'Services',
      seo_description: 'Catalogue complet des services {{companyName}}',
      eyebrow: 'Notre expertise',
      title: 'Services sur mesure',
      subtitle: 'Des solutions complètes pour entreprises, ONG, institutions et particuliers avec des standards internationaux.'
    },
    faq_page: {
      seo_title: 'FAQ',
      seo_description: 'Questions fréquentes {{companyName}}',
      title: 'FAQ',
      items: {
        multilingual: {
          q: 'Comment fonctionne le multilingue ?',
          a: 'Nous détectons la langue du navigateur et permettons la sélection manuelle en français, italien, anglais et portugais.'
        },
        payments: {
          q: 'Proposez-vous des paiements en ligne ?',
          a: 'Oui, via intégration Stripe avec facturation en EUR/USD/FCFA.'
        },
        admin_access: {
          q: 'Comment accéder au panneau admin ?',
          a: 'Les administrateurs disposent d’identifiants. L’authentification se fait via JWT + 2FA optionnel.'
        }
      }
    },
    forms: {
      choose: 'Choisir...',
      full_name: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      message: 'Message',
      details: 'Détails du besoin',
      service_type: 'Type de service',
      language_pair: 'Langues concernées',
      deadline: 'Date limite',
      budget: 'Budget estimé',
      attachments: 'Pièces jointes (optionnel)',
      attachments_help: 'Ajoutez des documents utiles (PDF, DOC, images).',
      description: 'Description',
      name_placeholder: 'Votre nom',
      email_placeholder: 'vous@email.com',
      message_placeholder: 'Votre besoin'
    },
    quote: {
      seo_title: 'Devis',
      page_title: 'Demande de devis',
      page_intro: "Recevez une estimation détaillée et un plan d'action en moins de 24h ouvrées.",
      missing_client: 'Configuration client manquante. Contactez un administrateur.',
      success: 'Votre demande a été envoyée. Nous revenons vers vous très vite.',
      confirm_title: 'Demande envoyée',
      confirm_intro: 'Nous avons bien reçu votre demande. Un chargé de compte vous recontacte sous 24h ouvrées.',
      labels: {
        reference: 'Référence',
        service: 'Service',
        contact: 'Contact',
        languages: 'Langues',
        budget: 'Budget',
        deadline: 'Date limite'
      },
      actions: {
        view_requests: 'Voir mes demandes',
        create_account: 'Créer un compte pour suivre la demande',
        back_home: 'Retour à l’accueil'
      },
      services: {
        interpreting: 'Interprétariat',
        translation: 'Traduction',
        administrative: 'Assistance administrative',
        planimetry: 'Planimétrie',
        events: 'Événementiel'
      }
    },
    contact_page: {
      seo_title: 'Contact',
      page_title: 'Entrons en contact',
      page_intro: 'Appelez-nous, écrivez-nous ou planifiez une visio. Nous parlons français, italien, anglais, portugais et lingala.',
      labels: {
        phone: 'Téléphone',
        email: 'Email',
        address: 'Adresse'
      },
      submit: 'Envoyer',
      submitting: 'Envoi...',
      missing_client: 'Configuration client manquante. Contactez un administrateur.',
      success: 'Message bien reçu. Nous revenons vers vous sous 24h ouvrées.'
    },
    service_detail: {
      eyebrow: 'Service',
      why_title: 'Pourquoi {{companyName}} ?',
      why_points: {
        p1: 'Réseau d’experts trilingues certifiés.',
        p2: 'Gestionnaire de projet dédié.',
        p3: 'Intégration avec plateforme client + admin.'
      },
      brief_title: 'Brief express',
      success: 'Demande envoyée. Nous revenons vers vous sous 24h ouvrées.',
      titles: {
        interpretariat: 'Interprétariat professionnel',
        traduction: 'Traduction certifiée',
        'assistance-administrative': 'Assistance linguistique et administrative',
        'cours-langues': 'Cours de langues',
        planimetrie: 'Planimétrie et topographie',
        evenementiel: 'Événementiel multilingue'
      },
      descriptions: {
        interpretariat: 'Conférences, panels, réunions diplomatiques et couvertures média en simultané ou consécutif.',
        traduction: 'Documents juridiques, contrats, marketing multilingue avec relecture double.',
        'assistance-administrative': 'Médiation culturelle, hotline multilingue, formalités et dossiers complexes.',
        'cours-langues': 'Parcours blended learning, préparation aux examens et coaching sectoriel.',
        planimetrie: 'Plans urbains, topographiques et cadastraux pour vos projets techniques.',
        evenementiel: 'Organisation, staffing et production pour conférences et lancements.'
      }
    },
    auth: {
      login: {
        title: 'Connexion',
        intro: 'Accédez à votre espace étudiant.',
        submit: 'Se connecter',
        submitting: 'Connexion...',
        no_account: 'Pas encore de compte ?',
        create_account: 'Créer un compte'
      },
      register: {
        title: 'Créer un compte',
        intro: 'Accédez à votre espace étudiant.',
        submit: 'Créer mon compte',
        submitting: 'Création...',
        already_registered: 'Déjà inscrit ?',
        sign_in: 'Se connecter',
        language: 'Langue',
        phone_optional: 'Téléphone (facultatif)',
        password: 'Mot de passe'
      }
    },
    portal: {
      brand: 'Espace étudiant',
      nav: {
        dashboard: 'Tableau de bord',
        requests: 'Mes demandes',
        preferences: 'Préférences'
      },
      logout: 'Se déconnecter',
      dashboard: {
        welcome: 'Bienvenue',
        signed_in_as: 'Connecté en tant que',
        intro: 'Retrouvez vos demandes et mettez à jour vos préférences de contact.',
        quick_access: 'Accès rapide',
        view_requests: 'Voir mes demandes',
        update_preferences: 'Mettre à jour mes préférences'
      },
      requests: {
        title: 'Mes demandes',
        loading: 'Chargement...',
        empty_title: 'Aucune demande trouvée.',
        empty_hint_prefix: 'Vous pouvez envoyer une demande via',
        quote: 'Devis',
        contact: 'Contact',
        reference: 'Référence'
      },
      preferences: {
        title: 'Préférences',
        language: 'Langue préférée',
        phone_optional: 'Téléphone (facultatif)',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        saved: 'Préférences mises à jour.'
      }
    },
    requests: {
      submitted: {
        title: 'Demande envoyée',
        reference_label: 'Numéro de dossier',
        copy: 'Copier le numéro',
        copied: 'Copié',
        download_receipt: 'Télécharger le reçu',
        receipt_title: 'Reçu de soumission',
        receipt_date_label: 'Date',
        receipt_site_label: 'Site',
        receipt_actions: 'Actions reçu',
        receipt_followup: 'Nous avons bien reçu votre demande. Vous serez recontacté pour les étapes suivantes.',
        receipt_disclaimer: 'Ce document est un simple accusé de réception et ne remplace aucun document légal ou contractuel.'
      }
    },
    service_request: {
      statuses: {
        new: 'Nouvelle',
        in_progress: 'En cours',
        scheduled: 'Planifiée',
        completed: 'Terminée',
        cancelled: 'Annulée'
      },
      types: {
        translation: 'Traduction',
        interpreting: 'Interprétariat',
        administrative: 'Assistance administrative'
      }
    },
    home: {
      title: 'Plateforme linguistique et administrative',
      seo_title: 'Accueil',
      seo_description: 'Services linguistiques, administratifs et événementiels de {{companyName}}',
      news: {
        eyebrow: 'Veille réglementaire',
        title: 'Actualités express',
        view_all: 'Voir toute la veille →',
        consult: 'Consulter →',
        aria: 'Actualités {{companyName}}',
        items: {
          import_2025: {
            title: 'Nouvelle réglementation logistique 2025',
            summary: 'Les nouvelles règles d’importation 2025 entrent en vigueur le 1er février. Notre cellule conformité prépare les dossiers bilingues et les notes aux autorités.',
            tag: 'Logistique',
            date: 'Fév. 2025'
          },
          marches_publics: {
            title: 'Réforme marchés publics BTP',
            summary: 'Publication du cahier des charges BIM obligatoire pour les appels d’offres para-publics. {{companyName}} met à jour les maquettes planimétrie.',
            tag: 'BTP',
            date: 'Jan. 2025'
          },
          immigration: {
            title: 'Procédures visas talents',
            summary: 'Nouveaux formulaires bilingues exigés par les consulats d’Italie et d’Espagne. Assistance administrative avec dépôt express disponible.',
            tag: 'Immigration',
            date: 'Déc. 2024'
          }
        }
      },
      expertises: {
        title: 'Nos expertises',
        subtitle: 'Programmes linguistiques, interprétariat et opérations terrain synchronisés.'
      },
      cta: {
        title: 'Besoin d’un devis en 24h ?',
        subtitle: 'Notre cellule administrative et linguistique prépare les estimations multilingues et accompagne vos procédures.',
        button: 'Demander un devis'
      }
    },
    hero: {
      slides: {
        interpreting: {
          title: 'Interprétariat premium',
          subtitle: 'Conventions internationales, forums, missions diplomatiques'
        },
        translation: {
          title: 'Traductions spécialisées',
          subtitle: 'Légal, médico-pharma, finance, industrie'
        },
        admin: {
          title: 'Assistance administrative',
          subtitle: 'Procédures complexes, médiation culturelle, forfait business'
        }
      },
      metrics: {
        years: 'Années d’expertise',
        clients: 'Clients accompagnés',
        countries: 'Pays couverts',
        languages: 'Langues disponibles'
      }
    },
    why_choose: {
      eyebrow: 'Pourquoi nous choisir',
      title: 'Un partenaire linguistique engagé',
      lead: '{{companyName}} orchestre des missions multilingues critiques avec une gouvernance projet inspirée des meilleures agences européennes.',
      reasons: {
        quality: {
          title: 'Qualité certifiée',
          description: 'Méthodologies inspirées des normes ISO 17100, relectures croisées et mémoires validées par industrie.'
        },
        team: {
          title: 'Équipe experte',
          description: 'Traducteurs natifs, terminologues et chefs de projet présents à Congo-Brazzaville et Italia.'
        },
        tech: {
          title: 'Technologie de pointe',
          description: 'Mémoires de traduction, IA de synthèse, connecteurs API pour CRM/ERP.'
        },
        confidentiality: {
          title: 'Confidentialité totale',
          description: 'Canaux chiffrés, NDA généralisés et hébergement souverain pour les dossiers sensibles.'
        },
        support: {
          title: 'Support 24/7',
          description: 'Cellule d’astreinte pour urgences juridiques, événements ou déplacements ministériels.'
        },
        sector: {
          title: 'Approche sectorielle',
          description: 'Binômes linguistes + experts métiers pour la santé, l’énergie, la finance et le luxe.'
        }
      }
    },
    sectors: {
      eyebrow: 'Secteurs d’intervention',
      title: 'Expertise sectorielle',
      subtitle: 'Nos chefs de projet associent linguistes natifs et consultants métiers pour restituer les nuances propres à votre industrie.',
      view_sector: 'Voir le secteur',
      back_to_list: 'Retour aux secteurs',
      metrics: {
        projects: 'Projets livrés',
        clients: 'Clients accompagnés',
        linguists: 'Interprètes & traducteurs'
      },
      detail: {
        what_we_do: 'Ce que nous couvrons',
        request: 'Brief express',
        form_title: 'Dites-nous votre besoin',
        contact: 'Parler à un chef de projet'
      },
      items: {
        industrie: {
          title: 'Production & industrie',
          description: 'Procédures, notices techniques, documentation de maintenance pour ateliers et usines.',
          services: ['Procédures de sécurité', 'Cahiers des charges', 'Notices de machines', 'Rapports d’usine']
        },
        sante: {
          title: 'Santé & pharma',
          description: 'Équipes médico-pharma pour essais cliniques, notices, dossiers patients.',
          services: ['Études cliniques', 'Notices de médicaments', 'Formulaires autorités', 'Articles scientifiques']
        },
        finance: {
          title: 'Finance & légal',
          description: 'Traductions certifiées, reporting IFRS, contrats multijuridictionnels.',
          services: ['Rapports annuels', 'Prospectus', 'Contrats', 'Due diligence']
        },
        energie: {
          title: 'Énergie & environnement',
          description: 'Projets d’énergie verte, audits environnementaux, conformité locale.',
          services: ['Études d’impact', 'Rapports techniques', 'Dossiers réglementaires', 'Plans de transition']
        }
      }
    },
    portfolio: {
      eyebrow: 'Références clients',
      title: 'Confiance des directions juridiques, RH et innovation',
      lead: 'Nous intervenons comme partenaire intégré : cellule linguistique, conformité documentaire et gestion de planning sont regroupées pour accélérer vos lancements.',
      marquee_aria: 'Clients accompagnés',
      stats: {
        countries: { label: 'Pays coordonnés', detail: 'Réseau linguistique & réglementaire' },
        response_time: { label: 'Temps moyen de réponse', detail: 'Cellule opérations dédiée' },
        satisfaction: { label: 'Satisfaction clients', detail: 'Enquêtes post-projet 2024' }
      },
      case_studies: {
        arcadis: {
          client: 'Consortium Arcadis',
          sector: 'Infrastructure & smart city',
          scope: '120 000 mots traduits (FR ⇄ IT ⇄ EN), coordination de 3 équipes, dépôt BIM bilingue',
          quote: '{{companyName}} a piloté toute la terminologie technique et la consolidation documentaire en moins de 10 jours malgré les fuseaux horaires.',
          result: 'Gain de 2 points sur la grille innovation, appel d’offres remporté en 2024'
        },
        helix: {
          client: 'Helix Biopharma',
          sector: 'Santé & pharmaceutique',
          scope: 'Dossiers EMA, notices patients, préparation audit autorités locales',
          quote: 'Le binôme chef de projet + consultant médical a fluidifié les échanges avec les agences réglementaires.',
          result: 'Validation anticipée des essais phase III, diffusion multilingue des notices'
        },
        nova: {
          client: 'Nova Energia',
          sector: 'Énergie renouvelable',
          scope: 'Rapports d’impact environnemental, contrats EPC multi-pays',
          quote: 'La cellule compliance a uniformisé les annexes juridiques pour nos partenaires européens.',
          result: 'Signature simultanée sur 5 marchés, conformité obtenue sans réserve'
        }
      }
    },
    credentials: {
      eyebrow: 'Reconnaissances institutionnelles',
      title: 'Nos accréditations & partenariats',
      lead: 'Mandats officiels et collaborations académiques qui renforcent notre mission de pont linguistique et administratif.',
      type_official: 'Mandat officiel',
      type_academic: 'Partenariat académique',
      consul: {
        title: 'Consul honoraire de la République fédérative du Brésil',
        org: 'Ministère des Relations Extérieures — Itamaraty',
        description: 'Désignation par Portaria nº 150 du 10 février 2026 pour exercer la fonction de consul honoraire à Pointe-Noire, République du Congo.',
        date: 'Février 2026 — mandat de 2 ans'
      },
      university: {
        title: 'Partenariat académique',
        org: 'Université partenaire',
        description: 'Convention de partenariat pour les programmes linguistiques, la formation professionnelle et les échanges académiques internationaux.',
        date: '2026'
      },
      note: 'D\'autres collaborations en cours de formalisation seront ajoutées ici.'
    },
    courses: {
      seo_title: 'Cours',
      seo_description: 'Plateforme e-learning {{companyName}}',
      title: 'Cours de langues',
      level: 'Niveau',
      hours_price: '{{hours}} heures',
      plan: 'Planifier une session',
      items: {
        fr_business: 'Français professionnel',
        it_business: 'Italien business',
        en_ngo: 'Anglais pour ONG'
      }
    },
    course_placeholder: {
      seo_title: 'Cours de langue générale',
      seo_description: 'Programme à venir',
      eyebrow: 'Cours de langues',
      title: 'Cours de langue générale',
      intro: 'Module détaillé en préparation. Notre équipe {{companyName}} peut déjà vous proposer un parcours adapté.',
      contact: 'Contactez-nous pour une session d’évaluation gratuite.',
      cta: 'Parler à un conseiller'
    },
    about: {
      seo_title: 'À propos',
      seo_description: 'Mission et équipe {{companyName}}',
      title: 'Qui sommes-nous',
      body: '{{companyName}} accompagne les organisations africaines et européennes avec un hub multilingue. Notre équipe rassemble interprètes, traducteurs, juristes, architectes événementiels et spécialistes de la data légale.',
      values: {
        impact: { title: 'Impact', body: 'Nous simplifions les démarches administratives et linguistiques pour accélérer les projets.' },
        trust: { title: 'Confiance', body: 'Gestion sécurisée des données, conformité RGPD et politiques internes strictes.' },
        innovation: { title: 'Innovation', body: 'Agent IA propriétaire, automatisation des workflows et veille législative.' }
      }
    },
    government_news: {
      title: 'Veille législative',
      intro: "Flux automatique alimenté par l'agent IA open source {{companyName}}.",
      loading: 'Chargement des publications...'
    },
    ai: {
      badge: 'Demande à Beaty',
      open_label: 'Ouvrir l’assistante Beaty',
      title: 'Beaty · Assistante IA',
      subtitle: 'Support administratif instantané',
      empty: 'Posez vos questions sur les procédures, cours ou devis.',
      loading: 'Analyse en cours...',
      placeholder: 'Question administrative...',
      send: 'Envoyer',
      fallback: 'Impossible de répondre pour le moment.',
      disclaimer: '⚠️ Réponse informative, vérifiez auprès des sources officielles.'
    },
    footer: {
      contacts: 'Contacts',
      address: 'Adresse',
      social: 'Social',
      rights: 'Tous droits réservés.',
      legal_updates: 'Veille légale',
      faq: 'FAQ',
      privacy: 'Confidentialité',
      cookies: 'Cookies',
      terms: 'Conditions'
    },
    legal: {
      privacy: {
        title: 'Politique de confidentialité',
        description: 'Comment {{companyName}} traite vos données.'
      },
      cookies: {
        title: 'Politique cookies',
        description: 'Informations sur les cookies et technologies similaires utilisées par {{companyName}}.'
      },
      terms: {
        title: 'Conditions d’utilisation',
        description: 'Conditions d’utilisation du site et des services {{companyName}}.'
      }
    }
  },
  it: {
    common: {
      or: 'o',
      discover_service: 'Scopri il servizio',
      previous: 'Precedente',
      next: 'Successivo',
      go_to: 'Vai a {{title}}'
    },
    header: {
      language_label: 'Cambia lingua',
      account: 'Account',
      account_aria: 'Apri l’area studenti',
      logout: 'Esci',
      menu_open: 'Apri menu',
      menu_close: 'Chiudi menu'
    },
    nav: {
      home: 'Home',
      services: 'Servizi',
      courses: 'Corsi',
      about: 'Chi siamo',
      contact: 'Contatti',
      quote: 'Preventivo',
      login: 'Accesso'
    },
    mega: {
      categories: {
        traductions: {
          label: 'TRADUZIONI',
          description: 'Legale, finanza, tecnico, medico',
          items: {
            legal: 'Traduzioni legali e asseverate',
            commercial: 'Traduzioni commerciali',
            financial: 'Traduzioni economico-finanziarie',
            technical: 'Traduzioni tecniche',
            medical: 'Traduzioni medico-farmaceutiche',
            literary: 'Traduzioni letterarie'
          }
        },
        interpretariat: {
          label: 'INTERPRETARIATO',
          description: 'Simultaneo, consecutivo, missioni diplomatiche',
          items: {
            consecutive: 'Interpretariato consecutivo',
            liaison: 'Interpretariato di trattativa',
            simultaneous: 'Interpretariato simultaneo',
            whispering: 'Interpretariato chuchotage'
          }
        },
        assistance: {
          label: 'ASSISTENZA LINGUISTICA',
          description: 'Supporto legale, hotline multilingua, mediazione',
          items: {
            legal: 'Pratiche legali e notarili',
            hotline: 'Assistenza linguistica telefonica',
            hostess: 'Accoglienza & hostess',
            assessment: 'Valutazione linguistica del personale',
            mediation: 'Mediazione culturale',
            business: 'Pacchetto business integrato'
          }
        },
        cours: {
          label: 'CORSI DI LINGUA',
          description: 'Formazione, esami, coaching per settore',
          items: {
            general: 'Corso di lingua generale',
            business: 'Corsi per aziende',
            one_to_one: 'Lezioni private (one-to-one)',
            exams: 'Preparazione agli esami',
            sector: 'Corsi specializzati per settore'
          }
        },
        planimetrie: {
          label: 'PLANIMETRIA',
          description: 'Piani urbani, topografia, catasto',
          items: {
            urbanism: 'Piani urbanistici',
            architectural: 'Piani architettonici',
            topo: 'Mappe topografiche',
            cadastral: 'Planimetrie catastali'
          }
        },
        evenementiel: {
          label: 'EVENTI',
          description: 'Conferenze, seminari, lanci prodotto',
          items: {
            conferences: 'Organizzazione conferenze',
            seminars: 'Seminari internazionali',
            launches: 'Lanci di prodotto',
            congresses: 'Congressi multilingua'
          }
        }
      },
      cta: {
        eyebrow: 'Accelera i tuoi progetti',
        title: 'Preventivo in 24h',
        description: 'Parla con un referente dedicato per dimensionare il team {{companyName}}.',
        button: 'Richiedi un preventivo'
      }
    },
    services: {
      interpretation: 'Interpretariato',
      translation: 'Traduzione',
      admin_assistance: 'Assistenza amministrativa',
      language_courses: 'Corsi di lingua',
      planimetry: 'Planimetria',
      events: 'Eventi',
      accents: {
        interpretariat: 'Simultanea / consecutiva',
        traduction: 'Certificate & rapide',
        'assistance-administrative': 'Due diligence & back-office',
        'cours-langues': 'Blended learning',
        planimetrie: 'Proiezioni e scenografia',
        evenementiel: 'Direzione di produzione'
      },
      explore: 'Esplora →',
      desc_interpretariat: 'Interpreti trilingue, missioni diplomatiche, simultanea e consecutiva.',
      desc_traduction: 'Traduzioni certificate con doppia revisione per documenti sensibili.',
      'desc_assistance-administrative': 'Back-office, mediazione culturale e supporto amministrativo premium.',
      'desc_cours-langues': 'Formazione su misura, coaching e preparazione agli esami.',
      desc_planimetrie: 'Planimetrie, topografia e documenti tecnici con controllo qualità.',
      desc_evenementiel: 'Produzione, staffing e coordinamento multilingue per eventi.'
    },
    buttons: {
      request_service: 'Richiedi questo servizio',
      view_prices: 'Vedi prezzi',
      send: 'Invia',
      sending: 'Invio...',
      send_request: 'Invia richiesta'
    },
    services_page: {
      seo_title: 'Servizi',
      seo_description: 'Catalogo completo dei servizi {{companyName}}',
      eyebrow: 'La nostra expertise',
      title: 'Servizi su misura',
      subtitle: 'Soluzioni complete per aziende, ONG, istituzioni e privati con standard internazionali.'
    },
    faq_page: {
      seo_title: 'FAQ',
      seo_description: 'Domande frequenti {{companyName}}',
      title: 'FAQ',
      items: {
        multilingual: {
          q: 'Come funziona il multilingue?',
          a: 'Rileviamo la lingua del browser e permettiamo la selezione manuale in francese, italiano, inglese e portoghese.'
        },
        payments: {
          q: 'Offrite pagamenti online?',
          a: 'Sì, tramite integrazione Stripe con fatturazione in EUR/USD/FCFA.'
        },
        admin_access: {
          q: 'Come si accede al pannello admin?',
          a: 'Gli amministratori hanno credenziali dedicate. Autenticazione JWT con 2FA opzionale.'
        }
      }
    },
    forms: {
      choose: 'Scegli...',
      full_name: 'Nome completo',
      email: 'Email',
      phone: 'Telefono',
      message: 'Messaggio',
      details: 'Dettagli della richiesta',
      service_type: 'Tipo di servizio',
      language_pair: 'Lingue interessate',
      deadline: 'Scadenza',
      budget: 'Budget stimato',
      attachments: 'Allegati (opzionale)',
      attachments_help: 'Carica documenti utili (PDF, DOC, immagini).',
      description: 'Descrizione',
      name_placeholder: 'Il tuo nome',
      email_placeholder: 'tu@email.com',
      message_placeholder: 'La tua esigenza'
    },
    quote: {
      seo_title: 'Preventivo',
      page_title: 'Richiesta preventivo',
      page_intro: 'Ricevi una stima dettagliata e un piano di azione entro 24 ore lavorative.',
      missing_client: 'Configurazione cliente mancante. Contatta un amministratore.',
      success: 'La tua richiesta è stata inviata. Ti ricontattiamo al più presto.',
      confirm_title: 'Richiesta inviata',
      confirm_intro: 'Abbiamo ricevuto la tua richiesta. Un referente ti ricontatterà entro 24 ore lavorative.',
      labels: {
        reference: 'Riferimento',
        service: 'Servizio',
        contact: 'Contatto',
        languages: 'Lingue',
        budget: 'Budget',
        deadline: 'Scadenza'
      },
      actions: {
        view_requests: 'Vedi le mie richieste',
        create_account: 'Crea un account per seguire la richiesta',
        back_home: 'Torna alla home'
      },
      services: {
        interpreting: 'Interpretariato',
        translation: 'Traduzione',
        administrative: 'Assistenza amministrativa',
        planimetry: 'Planimetria',
        events: 'Eventi'
      }
    },
    contact_page: {
      seo_title: 'Contatti',
      page_title: 'Contattaci',
      page_intro: 'Chiamaci, scrivici o pianifica una videochiamata. Parliamo francese, italiano, inglese, portoghese e lingala.',
      labels: {
        phone: 'Telefono',
        email: 'Email',
        address: 'Indirizzo'
      },
      submit: 'Invia',
      submitting: 'Invio...',
      missing_client: 'Configurazione cliente mancante. Contatta un amministratore.',
      success: 'Messaggio ricevuto. Ti ricontatteremo entro 24 ore lavorative.'
    },
    service_detail: {
      eyebrow: 'Servizio',
      why_title: 'Perché {{companyName}}?',
      why_points: {
        p1: 'Rete di esperti trilingue certificati.',
        p2: 'Project manager dedicato.',
        p3: 'Integrazione con piattaforma cliente + admin.'
      },
      brief_title: 'Brief rapido',
      success: 'Richiesta inviata. Ti ricontattiamo entro 24 ore lavorative.',
      titles: {
        interpretariat: 'Interpretariato professionale',
        traduction: 'Traduzione certificata',
        'assistance-administrative': 'Assistenza linguistica e amministrativa',
        'cours-langues': 'Corsi di lingua',
        planimetrie: 'Planimetria e topografia',
        evenementiel: 'Eventi multilingua'
      },
      descriptions: {
        interpretariat: 'Conferenze, panel, incontri diplomatici e coperture media in simultanea o consecutiva.',
        traduction: 'Documenti legali, contratti, marketing multilingua con doppia revisione.',
        'assistance-administrative': 'Mediazione culturale, hotline multilingua, pratiche e dossier complessi.',
        'cours-langues': 'Percorsi blended learning, preparazione esami e coaching per settore.',
        planimetrie: 'Piani urbani, topografici e catastali per progetti tecnici.',
        evenementiel: 'Organizzazione, staffing e produzione per conferenze e lanci.'
      }
    },
    auth: {
      login: {
        title: 'Accesso',
        intro: 'Accedi alla tua area studenti.',
        submit: 'Accedi',
        submitting: 'Accesso...',
        no_account: 'Non hai un account?',
        create_account: 'Crea un account'
      },
      register: {
        title: 'Crea un account',
        intro: 'Accedi alla tua area studenti.',
        submit: 'Crea il mio account',
        submitting: 'Creazione...',
        already_registered: 'Già registrato?',
        sign_in: 'Accedi',
        language: 'Lingua',
        phone_optional: 'Telefono (facoltativo)',
        password: 'Password'
      }
    },
    portal: {
      brand: 'Area studenti',
      nav: {
        dashboard: 'Dashboard',
        requests: 'Le mie richieste',
        preferences: 'Preferenze'
      },
      logout: 'Esci',
      dashboard: {
        welcome: 'Benvenuto',
        signed_in_as: 'Connesso come',
        intro: 'Consulta le tue richieste e aggiorna le preferenze di contatto.',
        quick_access: 'Accesso rapido',
        view_requests: 'Vedi le mie richieste',
        update_preferences: 'Aggiorna preferenze'
      },
      requests: {
        title: 'Le mie richieste',
        loading: 'Caricamento...',
        empty_title: 'Nessuna richiesta trovata.',
        empty_hint_prefix: 'Puoi inviare una richiesta tramite',
        quote: 'Preventivo',
        contact: 'Contatti',
        reference: 'Riferimento'
      },
      preferences: {
        title: 'Preferenze',
        language: 'Lingua preferita',
        phone_optional: 'Telefono (facoltativo)',
        save: 'Salva',
        saving: 'Salvataggio...',
        saved: 'Preferenze aggiornate.'
      }
    },
    requests: {
      submitted: {
        title: 'Richiesta inviata',
        reference_label: 'Numero pratica',
        copy: 'Copia numero pratica',
        copied: 'Copiato',
        download_receipt: 'Scarica ricevuta',
        receipt_title: 'Ricevuta invio richiesta',
        receipt_date_label: 'Data',
        receipt_site_label: 'Sito',
        receipt_actions: 'Azioni ricevuta',
        receipt_followup: 'Abbiamo ricevuto la tua richiesta. Sarai ricontattato per le procedure successive.',
        receipt_disclaimer: 'Questo documento è una semplice ricevuta di conferma ricezione e non sostituisce alcun documento legale o contrattuale.'
      }
    },
    service_request: {
      statuses: {
        new: 'Nuova',
        in_progress: 'In corso',
        scheduled: 'Pianificata',
        completed: 'Completata',
        cancelled: 'Annullata'
      },
      types: {
        translation: 'Traduzione',
        interpreting: 'Interpretariato',
        administrative: 'Assistenza amministrativa'
      }
    },
    home: {
      title: 'Piattaforma linguistica e amministrativa',
      seo_title: 'Home',
      seo_description: 'Servizi linguistici, amministrativi ed eventi di {{companyName}}',
      news: {
        eyebrow: 'Aggiornamenti normativi',
        title: 'Notizie rapide',
        view_all: 'Vedi tutti gli aggiornamenti →',
        consult: 'Apri →',
        aria: 'Notizie {{companyName}}',
        items: {
          import_2025: {
            title: 'Nuove regole logistiche 2025',
            summary: 'Le nuove regole di importazione 2025 entrano in vigore il 1° febbraio. Il nostro team compliance prepara dossier bilingui e note per le autorità.',
            tag: 'Logistica',
            date: 'Feb. 2025'
          },
          marches_publics: {
            title: 'Riforma appalti pubblici BTP',
            summary: 'Pubblicazione del capitolato BIM obbligatorio per bandi para-pubblici. {{companyName}} aggiorna i layout di planimetria.',
            tag: 'BTP',
            date: 'Gen. 2025'
          },
          immigration: {
            title: 'Procedure visti talenti',
            summary: 'Nuovi moduli bilingui richiesti dai consolati di Italia e Spagna. Disponibile assistenza amministrativa con deposito express.',
            tag: 'Immigrazione',
            date: 'Dic. 2024'
          }
        }
      },
      expertises: {
        title: 'Le nostre competenze',
        subtitle: 'Programmi linguistici, interpretariato e operazioni sul campo sincronizzate.'
      },
      cta: {
        title: 'Hai bisogno di un preventivo in 24h?',
        subtitle: 'Il nostro team amministrativo e linguistico prepara stime multilingue e segue le tue procedure.',
        button: 'Richiedi un preventivo'
      }
    },
    hero: {
      slides: {
        interpreting: {
          title: 'Interpretariato premium',
          subtitle: 'Convention internazionali, forum, missioni diplomatiche'
        },
        translation: {
          title: 'Traduzioni specialistiche',
          subtitle: 'Legale, medico-farmaceutico, finanza, industria'
        },
        admin: {
          title: 'Assistenza amministrativa',
          subtitle: 'Procedure complesse, mediazione culturale, pacchetto business'
        }
      },
      metrics: {
        years: 'Anni di esperienza',
        clients: 'Clienti seguiti',
        countries: 'Paesi coperti',
        languages: 'Lingue disponibili'
      }
    },
    why_choose: {
      eyebrow: 'Perché sceglierci',
      title: 'Un partner linguistico affidabile',
      lead: '{{companyName}} coordina missioni multilingue critiche con una governance di progetto ispirata alle migliori agenzie europee.',
      reasons: {
        quality: { title: 'Qualità certificata', description: 'Metodologie ispirate alle norme ISO 17100, doppia revisione e memorie validate per settore.' },
        team: { title: 'Team esperto', description: 'Traduttori madrelingua, terminologi e project manager tra Brazzaville e Roma.' },
        tech: { title: 'Tecnologia avanzata', description: 'Memorie di traduzione, AI, connettori API per CRM/ERP.' },
        confidentiality: { title: 'Riservatezza totale', description: 'Canali cifrati, NDA e hosting sicuro per pratiche sensibili.' },
        support: { title: 'Supporto 24/7', description: 'Reperibilità per urgenze legali, eventi o missioni.' },
        sector: { title: 'Approccio per settore', description: 'Coppie linguista + esperto per sanità, energia, finanza e lusso.' }
      }
    },
    sectors: {
      eyebrow: 'Settori di intervento',
      title: 'Competenza settoriale',
      subtitle: 'I nostri project manager uniscono linguisti madrelingua e consulenti di settore per rendere tutte le sfumature del tuo business.',
      view_sector: 'Vedi settore',
      back_to_list: 'Torna ai settori',
      metrics: {
        projects: 'Progetti consegnati',
        clients: 'Clienti seguiti',
        linguists: 'Interpreti e traduttori'
      },
      detail: {
        what_we_do: 'Cosa copriamo',
        request: 'Brief rapido',
        form_title: 'Raccontaci la tua esigenza',
        contact: 'Parla con un project manager'
      },
      items: {
        industrie: { title: 'Produzione e industria', description: 'Procedure, manuali tecnici e documentazione di manutenzione per officine e fabbriche.', services: ['Procedure di sicurezza', 'Capitolati', 'Manuali macchine', 'Report di stabilimento'] },
        sante: { title: 'Sanità e pharma', description: 'Team medico-farma per studi clinici, fogli illustrativi, dossier pazienti.', services: ['Studi clinici', 'Fogli illustrativi', 'Moduli autorità', 'Articoli scientifici'] },
        finance: { title: 'Finanza e legale', description: 'Traduzioni certificate, reporting IFRS, contratti multi-giurisdizione.', services: ['Bilanci', 'Prospetti', 'Contratti', 'Due diligence'] },
        energie: { title: 'Energia e ambiente', description: 'Progetti green, audit ambientali e compliance locale.', services: ['Studi di impatto', 'Report tecnici', 'Dossier normativi', 'Piani di transizione'] }
      }
    },
    portfolio: {
      eyebrow: 'Referenze clienti',
      title: 'Fiducia di direzioni legali, HR e innovazione',
      lead: 'Interveniamo come partner integrato: team linguistico, compliance documentale e gestione planning per accelerare i lanci.',
      marquee_aria: 'Clienti seguiti',
      stats: {
        countries: { label: 'Paesi coordinati', detail: 'Rete linguistica e regolatoria' },
        response_time: { label: 'Tempo medio di risposta', detail: 'Team operativo dedicato' },
        satisfaction: { label: 'Soddisfazione clienti', detail: 'Sondaggi post-progetto 2024' }
      },
      case_studies: {
        arcadis: {
          client: 'Consorzio Arcadis',
          sector: 'Infrastrutture & smart city',
          scope: '120.000 parole tradotte (FR ⇄ IT ⇄ EN), coordinamento 3 team, deposito BIM bilingue',
          quote: '{{companyName}} ha gestito terminologia tecnica e consolidamento documentale in meno di 10 giorni.',
          result: 'Appalto vinto nel 2024, +2 punti in innovazione'
        },
        helix: {
          client: 'Helix Biopharma',
          sector: 'Sanità & farmaceutico',
          scope: 'Dossier EMA, fogli illustrativi, preparazione audit autorità locali',
          quote: 'Il binomio project manager + consulente medico ha reso fluidi gli scambi con gli enti regolatori.',
          result: 'Validazione anticipata fase III e diffusione multilingue'
        },
        nova: {
          client: 'Nova Energia',
          sector: 'Energia rinnovabile',
          scope: 'Report di impatto ambientale, contratti EPC multi-paese',
          quote: 'Il team compliance ha uniformato gli allegati legali per partner europei.',
          result: 'Firma simultanea su 5 mercati, compliance senza riserve'
        }
      }
    },
    credentials: {
      eyebrow: 'Riconoscimenti istituzionali',
      title: 'Accreditamenti e partenariati',
      lead: 'Mandati ufficiali e collaborazioni accademiche che rafforzano la nostra missione di ponte linguistico e amministrativo.',
      type_official: 'Mandato ufficiale',
      type_academic: 'Partenariato accademico',
      consul: {
        title: 'Console onorario della Repubblica Federativa del Brasile',
        org: 'Ministero delle Relazioni Estere — Itamaraty',
        description: 'Designazione tramite Portaria nº 150 del 10 febbraio 2026 per esercitare la funzione di console onorario a Pointe-Noire, Repubblica del Congo.',
        date: 'Febbraio 2026 — mandato di 2 anni'
      },
      university: {
        title: 'Partenariato accademico',
        org: 'Università partner',
        description: 'Convenzione di partenariato per programmi linguistici, formazione professionale e scambi accademici internazionali.',
        date: '2026'
      },
      note: 'Altre collaborazioni in fase di formalizzazione saranno aggiunte qui.'
    },
    courses: {
      seo_title: 'Corsi',
      seo_description: 'Piattaforma e-learning {{companyName}}',
      title: 'Corsi di lingua',
      level: 'Livello',
      hours_price: '{{hours}} ore',
      plan: 'Pianifica una sessione',
      items: {
        fr_business: 'Francese professionale',
        it_business: 'Italiano business',
        en_ngo: 'Inglese per ONG'
      }
    },
    course_placeholder: {
      seo_title: 'Corso di lingua generale',
      seo_description: 'Programma in arrivo',
      eyebrow: 'Corsi di lingua',
      title: 'Corso di lingua generale',
      intro: 'Modulo dettagliato in preparazione. Il team {{companyName}} può già proporti un percorso dedicato.',
      contact: 'Contattaci per una sessione di valutazione gratuita.',
      cta: 'Parla con un consulente'
    },
    about: {
      seo_title: 'Chi siamo',
      seo_description: 'Mission e team {{companyName}}',
      title: 'Chi siamo',
      body: '{{companyName}} accompagna organizzazioni africane ed europee con un hub multilingue. Il team include interpreti, traduttori, legali, event architect e data specialist.',
      values: {
        impact: { title: 'Impatto', body: 'Semplifichiamo pratiche amministrative e linguistiche per accelerare i progetti.' },
        trust: { title: 'Fiducia', body: 'Gestione sicura dei dati, conformità GDPR e policy interne rigorose.' },
        innovation: { title: 'Innovazione', body: 'Agente IA proprietario, automazione dei workflow e monitoraggio normativo.' }
      }
    },
    government_news: {
      title: 'Monitoraggio normativo',
      intro: 'Feed automatico fornito dall’agente IA open source {{companyName}}.',
      loading: 'Caricamento delle pubblicazioni...'
    },
    ai: {
      badge: 'Chiedi a Beaty',
      open_label: "Apri l'assistente Beaty",
      title: 'Beaty · Assistente IA',
      subtitle: 'Supporto amministrativo istantaneo',
      empty: 'Fai domande su procedure, corsi o preventivi.',
      loading: 'Analisi in corso...',
      placeholder: 'Domanda amministrativa...',
      send: 'Invia',
      fallback: 'Impossibile rispondere ora.',
      disclaimer: '⚠️ Risposta informativa, verifica presso fonti ufficiali.'
    },
    footer: {
      contacts: 'Contatti',
      address: 'Indirizzo',
      social: 'Social',
      rights: 'Tutti i diritti riservati.',
      legal_updates: 'Aggiornamenti legali',
      faq: 'FAQ',
      privacy: 'Privacy',
      cookies: 'Cookie',
      terms: 'Termini'
    },
    legal: {
      privacy: {
        title: 'Informativa Privacy',
        description: 'Come {{companyName}} tratta i tuoi dati.'
      },
      cookies: {
        title: 'Cookie Policy',
        description: 'Informazioni su cookie e tecnologie simili utilizzate da {{companyName}}.'
      },
      terms: {
        title: 'Termini di servizio',
        description: 'Termini di utilizzo del sito e dei servizi {{companyName}}.'
      }
    }
  },
  en: {
    common: {
      or: 'or',
      discover_service: 'Discover the service',
      previous: 'Previous',
      next: 'Next',
      go_to: 'Go to {{title}}'
    },
    header: {
      language_label: 'Change language',
      account: 'Account',
      account_aria: 'Open student area',
      logout: 'Logout',
      menu_open: 'Open menu',
      menu_close: 'Close menu'
    },
    nav: {
      home: 'Home',
      services: 'Services',
      courses: 'Courses',
      about: 'About',
      contact: 'Contact',
      quote: 'Quote',
      login: 'Login'
    },
    mega: {
      categories: {
        traductions: {
          label: 'TRANSLATIONS',
          description: 'Legal, finance, technical, medical',
          items: {
            legal: 'Legal & certified translations',
            commercial: 'Business translations',
            financial: 'Financial translations',
            technical: 'Technical translations',
            medical: 'Medical & pharma translations',
            literary: 'Literary translations'
          }
        },
        interpretariat: {
          label: 'INTERPRETING',
          description: 'Simultaneous, consecutive, diplomatic missions',
          items: {
            consecutive: 'Consecutive interpreting',
            liaison: 'Liaison interpreting',
            simultaneous: 'Simultaneous interpreting',
            whispering: 'Whispered interpreting'
          }
        },
        assistance: {
          label: 'LINGUISTIC SUPPORT',
          description: 'Legal support, multilingual hotline, mediation',
          items: {
            legal: 'Legal & notary procedures',
            hotline: 'Phone-based language support',
            hostess: 'Hostess & reception services',
            assessment: 'Staff language assessment',
            mediation: 'Cultural mediation',
            business: 'Integrated business package'
          }
        },
        cours: {
          label: 'LANGUAGE COURSES',
          description: 'Training, exams, sector coaching',
          items: {
            general: 'General language course',
            business: 'Corporate courses',
            one_to_one: 'Private lessons (one-to-one)',
            exams: 'Exam preparation',
            sector: 'Sector-specific courses'
          }
        },
        planimetrie: {
          label: 'PLANIMETRY',
          description: 'Urban plans, topography, cadastre',
          items: {
            urbanism: 'Urban planning maps',
            architectural: 'Architectural plans',
            topo: 'Topographic maps',
            cadastral: 'Cadastral plans'
          }
        },
        evenementiel: {
          label: 'EVENTS',
          description: 'Conferences, seminars, product launches',
          items: {
            conferences: 'Conference organization',
            seminars: 'International seminars',
            launches: 'Product launches',
            congresses: 'Multilingual congresses'
          }
        }
      },
      cta: {
        eyebrow: 'Accelerate your projects',
        title: 'Quote in 24h',
        description: 'Talk to a dedicated account manager to size the {{companyName}} team.',
        button: 'Request a quote'
      }
    },
    services: {
      interpretation: 'Interpreting',
      translation: 'Translation',
      admin_assistance: 'Administrative assistance',
      language_courses: 'Language courses',
      planimetry: 'Planimetry',
      events: 'Events',
      accents: {
        interpretariat: 'Simultaneous / consecutive',
        traduction: 'Certified & express',
        'assistance-administrative': 'Due diligence & back-office',
        'cours-langues': 'Blended learning',
        planimetrie: 'Projection & scenography',
        evenementiel: 'Production direction'
      },
      explore: 'Explore →',
      desc_interpretariat: 'Trilingual interpreters, diplomatic missions, simultaneous and consecutive.',
      desc_traduction: 'Certified translations with double proofreading for sensitive documents.',
      'desc_assistance-administrative': 'Back-office, cultural mediation and premium admin support.',
      'desc_cours-langues': 'Tailored training, coaching and exam preparation.',
      desc_planimetrie: 'Plans, topography and technical files with quality control.',
      desc_evenementiel: 'Production, staffing and multilingual coordination for events.'
    },
    buttons: {
      request_service: 'Request this service',
      view_prices: 'View pricing',
      send: 'Send',
      sending: 'Sending...',
      send_request: 'Send request'
    },
    services_page: {
      seo_title: 'Services',
      seo_description: 'Full service catalog of {{companyName}}',
      eyebrow: 'Our expertise',
      title: 'Tailored services',
      subtitle: 'Complete solutions for companies, NGOs, institutions and individuals with international standards.'
    },
    faq_page: {
      seo_title: 'FAQ',
      seo_description: 'Frequently asked questions {{companyName}}',
      title: 'FAQ',
      items: {
        multilingual: {
          q: 'How does multilingual work?',
          a: 'We detect browser language and allow manual selection in French, Italian, English and Portuguese.'
        },
        payments: {
          q: 'Do you offer online payments?',
          a: 'Yes, via Stripe integration with billing in EUR/USD/FCFA.'
        },
        admin_access: {
          q: 'How to access the admin panel?',
          a: 'Admins have credentials. Authentication is JWT-based with optional 2FA.'
        }
      }
    },
    forms: {
      choose: 'Choose...',
      full_name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      details: 'Request details',
      service_type: 'Service type',
      language_pair: 'Languages',
      deadline: 'Deadline',
      budget: 'Estimated budget',
      attachments: 'Attachments (optional)',
      attachments_help: 'Upload helpful documents (PDF, DOC, images).',
      description: 'Description',
      name_placeholder: 'Your name',
      email_placeholder: 'you@email.com',
      message_placeholder: 'Your request'
    },
    quote: {
      seo_title: 'Quote',
      page_title: 'Request a quote',
      page_intro: 'Get a detailed estimate and action plan within 24 business hours.',
      missing_client: 'Missing client configuration. Please contact an administrator.',
      success: 'Your request has been sent. We will get back to you shortly.',
      confirm_title: 'Request sent',
      confirm_intro: 'We have received your request. An account manager will contact you within 24 business hours.',
      labels: {
        reference: 'Reference',
        service: 'Service',
        contact: 'Contact',
        languages: 'Languages',
        budget: 'Budget',
        deadline: 'Deadline'
      },
      actions: {
        view_requests: 'View my requests',
        create_account: 'Create an account to track the request',
        back_home: 'Back to home'
      },
      services: {
        interpreting: 'Interpreting',
        translation: 'Translation',
        administrative: 'Administrative assistance',
        planimetry: 'Planimetry',
        events: 'Events'
      }
    },
    contact_page: {
      seo_title: 'Contact',
      page_title: 'Get in touch',
      page_intro: 'Call us, write to us, or schedule a video call. We speak French, Italian, English, Portuguese and Lingala.',
      labels: {
        phone: 'Phone',
        email: 'Email',
        address: 'Address'
      },
      submit: 'Send',
      submitting: 'Sending...',
      missing_client: 'Missing client configuration. Please contact an administrator.',
      success: 'Message received. We will get back to you within 24 business hours.'
    },
    service_detail: {
      eyebrow: 'Service',
      why_title: 'Why {{companyName}}?',
      why_points: {
        p1: 'Network of certified trilingual experts.',
        p2: 'Dedicated project manager.',
        p3: 'Integration with client + admin platform.'
      },
      brief_title: 'Quick brief',
      success: 'Request sent. We will get back to you within 24 business hours.',
      titles: {
        interpretariat: 'Professional interpreting',
        traduction: 'Certified translation',
        'assistance-administrative': 'Linguistic & administrative support',
        'cours-langues': 'Language courses',
        planimetrie: 'Planimetry & topography',
        evenementiel: 'Multilingual events'
      },
      descriptions: {
        interpretariat: 'Conferences, panels, diplomatic meetings and media coverage, simultaneous or consecutive.',
        traduction: 'Legal documents, contracts, multilingual marketing with double proofreading.',
        'assistance-administrative': 'Cultural mediation, multilingual hotline, formalities and complex files.',
        'cours-langues': 'Blended learning paths, exam preparation and sector coaching.',
        planimetrie: 'Urban, topographic and cadastral plans for technical projects.',
        evenementiel: 'Organization, staffing and production for conferences and launches.'
      }
    },
    auth: {
      login: {
        title: 'Login',
        intro: 'Access your student area.',
        submit: 'Sign in',
        submitting: 'Signing in...',
        no_account: "Don't have an account?",
        create_account: 'Create an account'
      },
      register: {
        title: 'Create an account',
        intro: 'Access your student area.',
        submit: 'Create my account',
        submitting: 'Creating...',
        already_registered: 'Already registered?',
        sign_in: 'Sign in',
        language: 'Language',
        phone_optional: 'Phone (optional)',
        password: 'Password'
      }
    },
    portal: {
      brand: 'Student area',
      nav: {
        dashboard: 'Dashboard',
        requests: 'My requests',
        preferences: 'Preferences'
      },
      logout: 'Logout',
      dashboard: {
        welcome: 'Welcome',
        signed_in_as: 'Signed in as',
        intro: 'Find your requests and update your contact preferences.',
        quick_access: 'Quick access',
        view_requests: 'View my requests',
        update_preferences: 'Update my preferences'
      },
      requests: {
        title: 'My requests',
        loading: 'Loading...',
        empty_title: 'No requests found.',
        empty_hint_prefix: 'You can submit a request via',
        quote: 'Quote',
        contact: 'Contact',
        reference: 'Reference'
      },
      preferences: {
        title: 'Preferences',
        language: 'Preferred language',
        phone_optional: 'Phone (optional)',
        save: 'Save',
        saving: 'Saving...',
        saved: 'Preferences updated.'
      }
    },
    requests: {
      submitted: {
        title: 'Request sent',
        reference_label: 'Case number',
        copy: 'Copy case number',
        copied: 'Copied',
        download_receipt: 'Download receipt',
        receipt_title: 'Submission receipt',
        receipt_date_label: 'Date',
        receipt_site_label: 'Site',
        receipt_actions: 'Receipt actions',
        receipt_followup: 'We have received your request. You will be contacted for the next steps.',
        receipt_disclaimer: 'This document is a simple acknowledgement of receipt and does not replace any legal or contractual document.'
      }
    },
    service_request: {
      statuses: {
        new: 'New',
        in_progress: 'In progress',
        scheduled: 'Scheduled',
        completed: 'Completed',
        cancelled: 'Cancelled'
      },
      types: {
        translation: 'Translation',
        interpreting: 'Interpreting',
        administrative: 'Administrative assistance'
      }
    },
    home: {
      title: 'Language & admin operations platform',
      seo_title: 'Home',
      seo_description: 'Linguistic, administrative and events services by {{companyName}}',
      news: {
        eyebrow: 'Regulatory watch',
        title: 'News highlights',
        view_all: 'View all updates →',
        consult: 'Open →',
        aria: 'News {{companyName}}',
        items: {
          import_2025: {
            title: 'New logistics rules 2025',
            summary: 'New import rules for 2025 take effect on Feb 1st. Our compliance desk prepares bilingual files and notes for authorities.',
            tag: 'Logistics',
            date: 'Feb 2025'
          },
          marches_publics: {
            title: 'Public procurement reform (BTP)',
            summary: 'Mandatory BIM requirements for public tenders. {{companyName}} updates planimetry deliverables.',
            tag: 'Construction',
            date: 'Jan 2025'
          },
          immigration: {
            title: 'Talent visa procedures',
            summary: 'New bilingual forms required by Italy and Spain consulates. Admin assistance with express filing available.',
            tag: 'Immigration',
            date: 'Dec 2024'
          }
        }
      },
      expertises: {
        title: 'Our expertise',
        subtitle: 'Language programs, interpreting and field operations — aligned and coordinated.'
      },
      cta: {
        title: 'Need a quote within 24h?',
        subtitle: 'Our administrative and linguistic desk prepares multilingual estimates and supports your procedures.',
        button: 'Request a quote'
      }
    },
    hero: {
      slides: {
        interpreting: {
          title: 'Premium interpreting',
          subtitle: 'International conventions, forums, diplomatic missions'
        },
        translation: {
          title: 'Specialized translations',
          subtitle: 'Legal, pharma, finance, industry'
        },
        admin: {
          title: 'Administrative assistance',
          subtitle: 'Complex procedures, cultural mediation, business package'
        }
      },
      metrics: {
        years: 'Years of expertise',
        clients: 'Clients supported',
        countries: 'Countries covered',
        languages: 'Languages available'
      }
    },
    why_choose: {
      eyebrow: 'Why choose us',
      title: 'A committed language partner',
      lead: '{{companyName}} runs critical multilingual missions with project governance inspired by top European agencies.',
      reasons: {
        quality: { title: 'Certified quality', description: 'ISO 17100-inspired processes, cross reviews, and industry-validated memories.' },
        team: { title: 'Expert team', description: 'Native translators, terminologists and project managers in Brazzaville and Rome.' },
        tech: { title: 'Advanced technology', description: 'Translation memories, AI, and API connectors for CRM/ERP.' },
        confidentiality: { title: 'Full confidentiality', description: 'Encrypted channels, NDAs, and secure hosting for sensitive files.' },
        support: { title: '24/7 support', description: 'On-call desk for legal emergencies, events or official travel.' },
        sector: { title: 'Sector approach', description: 'Linguist + domain expert pairing for health, energy, finance and luxury.' }
      }
    },
    sectors: {
      eyebrow: 'Sectors we serve',
      title: 'Sector expertise',
      subtitle: 'Our project managers combine native linguists and domain consultants to capture the nuances of your industry.',
      view_sector: 'View sector',
      back_to_list: 'Back to sectors',
      metrics: {
        projects: 'Projects delivered',
        clients: 'Clients served',
        linguists: 'Interpreters & translators'
      },
      detail: {
        what_we_do: 'What we cover',
        request: 'Quick brief',
        form_title: 'Tell us your need',
        contact: 'Talk to a project lead'
      },
      items: {
        industrie: { title: 'Manufacturing & industry', description: 'Procedures, technical manuals and maintenance documentation for plants and workshops.', services: ['Safety procedures', 'Specifications', 'Machine manuals', 'Factory reports'] },
        sante: { title: 'Healthcare & pharma', description: 'Medical-pharma teams for clinical trials, leaflets, patient files.', services: ['Clinical studies', 'Medicine leaflets', 'Authority forms', 'Scientific papers'] },
        finance: { title: 'Finance & legal', description: 'Certified translations, IFRS reporting, multi-jurisdiction contracts.', services: ['Annual reports', 'Prospectuses', 'Contracts', 'Due diligence'] },
        energie: { title: 'Energy & environment', description: 'Green energy projects, environmental audits, local compliance.', services: ['Impact studies', 'Technical reports', 'Regulatory files', 'Transition plans'] }
      }
    },
    portfolio: {
      eyebrow: 'Client references',
      title: 'Trusted by legal, HR and innovation teams',
      lead: 'We act as an integrated partner: linguistic desk, document compliance and scheduling are consolidated to accelerate your launches.',
      marquee_aria: 'Clients supported',
      stats: {
        countries: { label: 'Countries coordinated', detail: 'Linguistic & regulatory network' },
        response_time: { label: 'Average response time', detail: 'Dedicated operations desk' },
        satisfaction: { label: 'Client satisfaction', detail: 'Post-project surveys 2024' }
      },
      case_studies: {
        arcadis: {
          client: 'Arcadis Consortium',
          sector: 'Infrastructure & smart city',
          scope: '120,000 words translated (FR ⇄ IT ⇄ EN), 3 teams coordinated, bilingual BIM submission',
          quote: '{{companyName}} managed technical terminology and document consolidation in under 10 days across time zones.',
          result: 'Won the tender in 2024, +2 innovation points'
        },
        helix: {
          client: 'Helix Biopharma',
          sector: 'Healthcare & pharmaceutical',
          scope: 'EMA files, patient leaflets, local authority audit preparation',
          quote: 'The PM + medical consultant pair streamlined communication with regulatory agencies.',
          result: 'Early phase III validation and multilingual distribution'
        },
        nova: {
          client: 'Nova Energia',
          sector: 'Renewable energy',
          scope: 'Environmental impact reports, multi-country EPC contracts',
          quote: 'Our compliance desk standardized legal annexes for European partners.',
          result: 'Simultaneous signatures across 5 markets, compliance without remarks'
        }
      }
    },
    credentials: {
      eyebrow: 'Institutional recognitions',
      title: 'Our accreditations & partnerships',
      lead: 'Official mandates and academic collaborations that strengthen our mission as a linguistic and administrative bridge.',
      type_official: 'Official mandate',
      type_academic: 'Academic partnership',
      consul: {
        title: 'Honorary Consul of the Federative Republic of Brazil',
        org: 'Ministry of Foreign Affairs — Itamaraty',
        description: 'Designation by Portaria nº 150 of February 10, 2026 to serve as honorary consul in Pointe-Noire, Republic of Congo.',
        date: 'February 2026 — 2-year mandate'
      },
      university: {
        title: 'Academic partnership',
        org: 'Partner university',
        description: 'Partnership agreement for linguistic programs, professional training and international academic exchanges.',
        date: '2026'
      },
      note: 'Additional collaborations being formalized will be added here.'
    },
    courses: {
      seo_title: 'Courses',
      seo_description: 'E-learning platform {{companyName}}',
      title: 'Language courses',
      level: 'Level',
      hours_price: '{{hours}} hours',
      plan: 'Schedule a session',
      items: {
        fr_business: 'Professional French',
        it_business: 'Business Italian',
        en_ngo: 'English for NGOs'
      }
    },
    course_placeholder: {
      seo_title: 'General language course',
      seo_description: 'Program coming soon',
      eyebrow: 'Language courses',
      title: 'General language course',
      intro: 'Detailed module in progress. The {{companyName}} team can already tailor a learning path.',
      contact: 'Contact us for a free assessment session.',
      cta: 'Talk to an advisor'
    },
    about: {
      seo_title: 'About',
      seo_description: 'Mission and team {{companyName}}',
      title: 'Who we are',
      body: '{{companyName}} supports African and European organizations with a multilingual hub. The team includes interpreters, translators, legal experts, event architects and data specialists.',
      values: {
        impact: { title: 'Impact', body: 'We simplify administrative and linguistic tasks to accelerate projects.' },
        trust: { title: 'Trust', body: 'Secure data handling, GDPR compliance and strict internal policies.' },
        innovation: { title: 'Innovation', body: 'Proprietary AI agent, workflow automation and regulatory watch.' }
      }
    },
    government_news: {
      title: 'Regulatory watch',
      intro: 'Automatic feed powered by the open-source AI agent {{companyName}}.',
      loading: 'Loading publications...'
    },
    ai: {
      badge: 'Ask Beaty',
      open_label: 'Open Beaty assistant',
      title: 'Beaty · AI assistant',
      subtitle: 'Instant administrative support',
      empty: 'Ask about procedures, courses, or quotes.',
      loading: 'Analyzing...',
      placeholder: 'Administrative question...',
      send: 'Send',
      fallback: 'Cannot respond right now.',
      disclaimer: '⚠️ Informational answer, verify with official sources.'
    },
    footer: {
      contacts: 'Contacts',
      address: 'Address',
      social: 'Social',
      rights: 'All rights reserved.',
      legal_updates: 'Legal updates',
      faq: 'FAQ',
      privacy: 'Privacy',
      cookies: 'Cookies',
      terms: 'Terms'
    },
    legal: {
      privacy: {
        title: 'Privacy Policy',
        description: 'How {{companyName}} processes your data.'
      },
      cookies: {
        title: 'Cookie Policy',
        description: 'Information about cookies and similar technologies used by {{companyName}}.'
      },
      terms: {
        title: 'Terms of Service',
        description: 'Terms for using the website and services of {{companyName}}.'
      }
    }
  },
  'pt-BR': {
    common: {
      or: 'ou',
      discover_service: 'Descobrir o serviço',
      previous: 'Anterior',
      next: 'Seguinte',
      go_to: 'Ir para {{title}}'
    },
    header: {
      language_label: 'Mudar idioma',
      account: 'Conta',
      account_aria: 'Abrir área do estudante',
      logout: 'Sair',
      menu_open: 'Abrir menu',
      menu_close: 'Fechar menu'
    },
    nav: {
      home: 'Início',
      services: 'Serviços',
      courses: 'Cursos',
      about: 'Sobre',
      contact: 'Contato',
      quote: 'Orçamento',
      login: 'Entrar'
    },
    mega: {
      categories: {
        traductions: {
          label: 'TRADUÇÕES',
          description: 'Jurídico, finanças, técnico, médico',
          items: {
            legal: 'Traduções jurídicas e certificadas',
            commercial: 'Traduções comerciais',
            financial: 'Traduções financeiras',
            technical: 'Traduções técnicas',
            medical: 'Traduções médicas e farmacêuticas',
            literary: 'Traduções literárias'
          }
        },
        interpretariat: {
          label: 'INTERPRETAÇÃO',
          description: 'Simultânea, consecutiva, missões diplomáticas',
          items: {
            consecutive: 'Interpretação consecutiva',
            liaison: 'Interpretação de ligação',
            simultaneous: 'Interpretação simultânea',
            whispering: 'Interpretação sussurrada'
          }
        },
        assistance: {
          label: 'SUPORTE LINGUÍSTICO',
          description: 'Apoio jurídico, hotline multilingue, mediação',
          items: {
            legal: 'Procedimentos legais e notariais',
            hotline: 'Suporte linguístico por telefone',
            hostess: 'Serviço de hostess e receção',
            assessment: 'Avaliação linguística do pessoal',
            mediation: 'Mediação cultural',
            business: 'Pacote business integrado'
          }
        },
        cours: {
          label: 'CURSOS DE LÍNGUAS',
          description: 'Formação, exames, coaching setorial',
          items: {
            general: 'Curso de língua geral',
            business: 'Cursos para empresas',
            one_to_one: 'Aulas particulares (one-to-one)',
            exams: 'Preparação para exames',
            sector: 'Cursos por setor'
          }
        },
        planimetrie: {
          label: 'PLANIMETRIA',
          description: 'Planos urbanos, topografia, cadastro',
          items: {
            urbanism: 'Mapas de urbanismo',
            architectural: 'Plantas arquitetónicas',
            topo: 'Mapas topográficos',
            cadastral: 'Plantas cadastrais'
          }
        },
        evenementiel: {
          label: 'EVENTOS',
          description: 'Conferências, seminários, lançamentos',
          items: {
            conferences: 'Organização de conferências',
            seminars: 'Seminários internacionais',
            launches: 'Lançamentos de produtos',
            congresses: 'Congressos multilingues'
          }
        }
      },
      cta: {
        eyebrow: 'Acelere os seus projetos',
        title: 'Orçamento em 24h',
        description: 'Fale com um gestor dedicado para dimensionar a equipa {{companyName}}.',
        button: 'Pedir orçamento'
      }
    },
    services: {
      interpretation: 'Interpretação',
      translation: 'Tradução',
      admin_assistance: 'Assistência administrativa',
      language_courses: 'Cursos de línguas',
      planimetry: 'Planimetria',
      events: 'Eventos',
      accents: {
        interpretariat: 'Simultânea / consecutiva',
        traduction: 'Certificadas e express',
        'assistance-administrative': 'Due diligence e back-office',
        'cours-langues': 'Blended learning',
        planimetrie: 'Projeção e cenografia',
        evenementiel: 'Direção de produção'
      },
      explore: 'Explorar →',
      desc_interpretariat: 'Intérpretes trilíngues, missões diplomáticas, simultânea e consecutiva.',
      desc_traduction: 'Traduções certificadas com dupla revisão para documentos sensíveis.',
      'desc_assistance-administrative': 'Back-office, mediação cultural e apoio administrativo premium.',
      'desc_cours-langues': 'Formação à medida, coaching e preparação para exames.',
      desc_planimetrie: 'Plantas, topografia e dossiês técnicos com controlo de qualidade.',
      desc_evenementiel: 'Produção, staffing e coordenação multilingue para eventos.'
    },
    buttons: {
      request_service: 'Pedir este serviço',
      view_prices: 'Ver preços',
      send: 'Enviar',
      sending: 'A enviar...',
      send_request: 'Enviar pedido'
    },
    services_page: {
      seo_title: 'Serviços',
      seo_description: 'Catálogo completo de serviços de {{companyName}}',
      eyebrow: 'A nossa experiência',
      title: 'Serviços à medida',
      subtitle: 'Soluções completas para empresas, ONGs, instituições e particulares com padrões internacionais.'
    },
    faq_page: {
      seo_title: 'FAQ',
      seo_description: 'Perguntas frequentes {{companyName}}',
      title: 'FAQ',
      items: {
        multilingual: {
          q: 'Como funciona o multilingue?',
          a: 'Detetamos o idioma do navegador e permitimos seleção manual em francês, italiano, inglês e português.'
        },
        payments: {
          q: 'Oferecem pagamentos online?',
          a: 'Sim, via integração Stripe com faturação em EUR/USD/FCFA.'
        },
        admin_access: {
          q: 'Como aceder ao painel de administração?',
          a: 'Os administradores têm credenciais. A autenticação é via JWT com 2FA opcional.'
        }
      }
    },
    forms: {
      choose: 'Escolher...',
      full_name: 'Nome completo',
      email: 'Email',
      phone: 'Telefone',
      message: 'Mensagem',
      details: 'Detalhes do pedido',
      service_type: 'Tipo de serviço',
      language_pair: 'Línguas',
      deadline: 'Prazo',
      budget: 'Orçamento estimado',
      attachments: 'Anexos (opcional)',
      attachments_help: 'Envie documentos úteis (PDF, DOC, imagens).',
      description: 'Descrição',
      name_placeholder: 'O seu nome',
      email_placeholder: 'voce@email.com',
      message_placeholder: 'O seu pedido'
    },
    quote: {
      seo_title: 'Orçamento',
      page_title: 'Pedir orçamento',
      page_intro: 'Receba uma estimativa detalhada e um plano de ação em até 24 horas úteis.',
      missing_client: 'Configuração do cliente em falta. Contacte um administrador.',
      success: 'O seu pedido foi enviado. Entraremos em contacto em breve.',
      confirm_title: 'Pedido enviado',
      confirm_intro: 'Recebemos o seu pedido. Um gestor entrará em contacto em até 24 horas úteis.',
      labels: {
        reference: 'Referência',
        service: 'Serviço',
        contact: 'Contacto',
        languages: 'Línguas',
        budget: 'Orçamento',
        deadline: 'Prazo'
      },
      actions: {
        view_requests: 'Ver os meus pedidos',
        create_account: 'Criar conta para acompanhar o pedido',
        back_home: 'Voltar ao início'
      },
      services: {
        interpreting: 'Interpretação',
        translation: 'Tradução',
        administrative: 'Assistência administrativa',
        planimetry: 'Planimetria',
        events: 'Eventos'
      }
    },
    contact_page: {
      seo_title: 'Contacto',
      page_title: 'Entre em contacto',
      page_intro: 'Ligue-nos, escreva-nos ou marque uma videochamada. Falamos francês, italiano, inglês, português e lingala.',
      labels: {
        phone: 'Telefone',
        email: 'Email',
        address: 'Endereço'
      },
      submit: 'Enviar',
      submitting: 'A enviar...',
      missing_client: 'Configuração do cliente em falta. Contacte um administrador.',
      success: 'Mensagem recebida. Entraremos em contacto em até 24 horas úteis.'
    },
    service_detail: {
      eyebrow: 'Serviço',
      why_title: 'Porquê {{companyName}}?',
      why_points: {
        p1: 'Rede de especialistas trilíngues certificados.',
        p2: 'Gestor de projeto dedicado.',
        p3: 'Integração com a plataforma cliente + admin.'
      },
      brief_title: 'Brief rápido',
      success: 'Pedido enviado. Entraremos em contacto em até 24 horas úteis.',
      titles: {
        interpretariat: 'Interpretação profissional',
        traduction: 'Tradução certificada',
        'assistance-administrative': 'Apoio linguístico e administrativo',
        'cours-langues': 'Cursos de línguas',
        planimetrie: 'Planimetria e topografia',
        evenementiel: 'Eventos multilingues'
      },
      descriptions: {
        interpretariat: 'Conferências, painéis, reuniões diplomáticas e cobertura mediática em simultânea ou consecutiva.',
        traduction: 'Documentos jurídicos, contratos, marketing multilingue com dupla revisão.',
        'assistance-administrative': 'Mediação cultural, hotline multilingue, formalidades e processos complexos.',
        'cours-langues': 'Percursos blended learning, preparação para exames e coaching setorial.',
        planimetrie: 'Plantas urbanas, topográficas e cadastrais para projetos técnicos.',
        evenementiel: 'Organização, staffing e produção para conferências e lançamentos.'
      }
    },
    auth: {
      login: {
        title: 'Entrar',
        intro: 'Acesse sua área do estudante.',
        submit: 'Entrar',
        submitting: 'A entrar...',
        no_account: 'Ainda não tem conta?',
        create_account: 'Criar conta'
      },
      register: {
        title: 'Criar conta',
        intro: 'Acesse sua área do estudante.',
        submit: 'Criar a minha conta',
        submitting: 'A criar...',
        already_registered: 'Já está registado?',
        sign_in: 'Entrar',
        language: 'Idioma',
        phone_optional: 'Telefone (opcional)',
        password: 'Senha'
      }
    },
    portal: {
      brand: 'Área do estudante',
      nav: {
        dashboard: 'Painel',
        requests: 'Os meus pedidos',
        preferences: 'Preferências'
      },
      logout: 'Sair',
      dashboard: {
        welcome: 'Bem-vindo',
        signed_in_as: 'Ligado como',
        intro: 'Consulte os seus pedidos e atualize as suas preferências de contacto.',
        quick_access: 'Acesso rápido',
        view_requests: 'Ver os meus pedidos',
        update_preferences: 'Atualizar preferências'
      },
      requests: {
        title: 'Os meus pedidos',
        loading: 'A carregar...',
        empty_title: 'Nenhum pedido encontrado.',
        empty_hint_prefix: 'Pode submeter um pedido via',
        quote: 'Orçamento',
        contact: 'Contato',
        reference: 'Referência'
      },
      preferences: {
        title: 'Preferências',
        language: 'Idioma preferido',
        phone_optional: 'Telefone (opcional)',
        save: 'Guardar',
        saving: 'A guardar...',
        saved: 'Preferências atualizadas.'
      }
    },
    requests: {
      submitted: {
        title: 'Pedido enviado',
        reference_label: 'Número do processo',
        copy: 'Copiar número do processo',
        copied: 'Copiado',
        download_receipt: 'Baixar recibo',
        receipt_title: 'Recibo de envio',
        receipt_date_label: 'Data',
        receipt_site_label: 'Site',
        receipt_actions: 'Ações do recibo',
        receipt_followup: 'Recebemos o seu pedido. Entraremos em contacto para os próximos passos.',
        receipt_disclaimer: 'Este documento é apenas um comprovativo de recebimento e não substitui qualquer documento legal ou contratual.'
      }
    },
    service_request: {
      statuses: {
        new: 'Novo',
        in_progress: 'Em curso',
        scheduled: 'Agendado',
        completed: 'Concluído',
        cancelled: 'Cancelado'
      },
      types: {
        translation: 'Tradução',
        interpreting: 'Interpretação',
        administrative: 'Assistência administrativa'
      }
    },
    home: {
      title: 'Plataforma de operações linguísticas e administrativas',
      seo_title: 'Início',
      seo_description: 'Serviços linguísticos, administrativos e de eventos por {{companyName}}',
      news: {
        eyebrow: 'Monitorização regulatória',
        title: 'Destaques',
        view_all: 'Ver todas as atualizações →',
        consult: 'Abrir →',
        aria: 'Notícias {{companyName}}',
        items: {
          import_2025: {
            title: 'Novas regras logísticas 2025',
            summary: 'Novas regras de importação para 2025 entram em vigor a 1 de fevereiro. A nossa equipa de compliance prepara dossiês e notas bilingues para autoridades.',
            tag: 'Logística',
            date: 'Fev 2025'
          },
          marches_publics: {
            title: 'Reforma de contratação pública (BTP)',
            summary: 'Requisitos BIM obrigatórios para concursos públicos. {{companyName}} atualiza entregáveis de planimetria.',
            tag: 'Construção',
            date: 'Jan 2025'
          },
          immigration: {
            title: 'Procedimentos de visto talento',
            summary: 'Novos formulários bilingues exigidos pelos consulados de Itália e Espanha. Assistência administrativa com submissão expresso disponível.',
            tag: 'Imigração',
            date: 'Dez 2024'
          }
        }
      },
      expertises: {
        title: 'A nossa experiência',
        subtitle: 'Programas linguísticos, interpretação e operações no terreno — alinhados e coordenados.'
      },
      cta: {
        title: 'Precisa de um orçamento em 24h?',
        subtitle: 'A nossa equipa administrativa e linguística prepara estimativas multilingues e apoia os seus procedimentos.',
        button: 'Pedir orçamento'
      }
    },
    hero: {
      slides: {
        interpreting: {
          title: 'Interpretação premium',
          subtitle: 'Convenções internacionais, fóruns, missões diplomáticas'
        },
        translation: {
          title: 'Traduções especializadas',
          subtitle: 'Jurídico, farmacêutico, finanças, indústria'
        },
        admin: {
          title: 'Assistência administrativa',
          subtitle: 'Processos complexos, mediação cultural, pacote business'
        }
      },
      metrics: {
        years: 'Anos de experiência',
        clients: 'Clientes apoiados',
        countries: 'Países cobertos',
        languages: 'Línguas disponíveis'
      }
    },
    why_choose: {
      eyebrow: 'Porquê escolher-nos',
      title: 'Um parceiro linguístico comprometido',
      lead: '{{companyName}} conduz missões multilingues críticas com governação de projeto inspirada nas melhores agências europeias.',
      reasons: {
        quality: { title: 'Qualidade certificada', description: 'Processos inspirados na ISO 17100, revisões cruzadas e memórias validadas pelo setor.' },
        team: { title: 'Equipa especializada', description: 'Tradutores nativos, terminólogos e gestores de projeto em Brazzaville e Roma.' },
        tech: { title: 'Tecnologia avançada', description: 'Memórias de tradução, IA e conectores API para CRM/ERP.' },
        confidentiality: { title: 'Confidencialidade total', description: 'Canais encriptados, NDAs e alojamento seguro para ficheiros sensíveis.' },
        support: { title: 'Suporte 24/7', description: 'Equipa de urgência para emergências legais, eventos ou viagens oficiais.' },
        sector: { title: 'Abordagem por setor', description: 'Dupla linguista + especialista de domínio para saúde, energia, finanças e luxo.' }
      }
    },
    sectors: {
      eyebrow: 'Setores',
      title: 'Experiência por setor',
      subtitle: 'Os nossos gestores combinam linguistas nativos e consultores de domínio para captar nuances do seu setor.',
      view_sector: 'Ver setor',
      back_to_list: 'Voltar aos setores',
      metrics: {
        projects: 'Projetos entregues',
        clients: 'Clientes servidos',
        linguists: 'Intérpretes e tradutores'
      },
      detail: {
        what_we_do: 'O que cobrimos',
        request: 'Brief rápido',
        form_title: 'Conte-nos a sua necessidade',
        contact: 'Falar com um responsável'
      },
      items: {
        industrie: { title: 'Indústria', description: 'Procedimentos, manuais técnicos e documentação de manutenção para fábricas e oficinas.', services: ['Procedimentos de segurança', 'Especificações', 'Manuais de máquinas', 'Relatórios de fábrica'] },
        sante: { title: 'Saúde e farmacêutica', description: 'Equipas médico-farma para ensaios clínicos, folhetos, processos de doentes.', services: ['Estudos clínicos', 'Folhetos de medicamentos', 'Formulários de autoridades', 'Artigos científicos'] },
        finance: { title: 'Finanças e jurídico', description: 'Traduções certificadas, relatórios IFRS, contratos multi-jurisdição.', services: ['Relatórios anuais', 'Prospectos', 'Contratos', 'Due diligence'] },
        energie: { title: 'Energia e ambiente', description: 'Projetos de energia verde, auditorias ambientais e conformidade local.', services: ['Estudos de impacto', 'Relatórios técnicos', 'Dossiês regulatórios', 'Planos de transição'] }
      }
    },
    portfolio: {
      eyebrow: 'Referências',
      title: 'Confiado por equipas jurídicas, RH e inovação',
      lead: 'Atuamos como parceiro integrado: gestão linguística, conformidade documental e agendamento consolidados para acelerar lançamentos.',
      marquee_aria: 'Clientes apoiados',
      stats: {
        countries: { label: 'Países coordenados', detail: 'Rede linguística e regulatória' },
        response_time: { label: 'Tempo médio de resposta', detail: 'Equipa de operações dedicada' },
        satisfaction: { label: 'Satisfação do cliente', detail: 'Inquéritos pós-projeto 2024' }
      },
      case_studies: {
        arcadis: {
          client: 'Arcadis Consortium',
          sector: 'Infraestrutura e smart city',
          scope: '120.000 palavras traduzidas (FR ⇄ IT ⇄ EN), 3 equipas coordenadas, submissão BIM bilingue',
          quote: '{{companyName}} geriu terminologia técnica e consolidação documental em menos de 10 dias entre fusos horários.',
          result: 'Concurso ganho em 2024, +2 pontos de inovação'
        },
        helix: {
          client: 'Helix Biopharma',
          sector: 'Saúde e farmacêutica',
          scope: 'Dossiês EMA, folhetos, preparação de auditoria para autoridades locais',
          quote: 'A dupla gestor + consultor médico simplificou a comunicação com agências regulatórias.',
          result: 'Validação fase III antecipada e distribuição multilingue'
        },
        nova: {
          client: 'Nova Energia',
          sector: 'Energias renováveis',
          scope: 'Relatórios de impacto ambiental, contratos EPC multi-país',
          quote: 'A nossa equipa de compliance normalizou anexos legais para parceiros europeus.',
          result: 'Assinaturas simultâneas em 5 mercados, compliance sem observações'
        }
      }
    },
    credentials: {
      eyebrow: 'Reconhecimentos institucionais',
      title: 'Nossas acreditações e parcerias',
      lead: 'Mandatos oficiais e colaborações acadêmicas que reforçam nossa missão de ponte linguística e administrativa.',
      type_official: 'Mandato oficial',
      type_academic: 'Parceria acadêmica',
      consul: {
        title: 'Cônsul honorário da República Federativa do Brasil',
        org: 'Ministério das Relações Exteriores — Itamaraty',
        description: 'Designação pela Portaria nº 150 de 10 de fevereiro de 2026 para exercer a função de cônsul honorário em Pointe-Noire, República do Congo.',
        date: 'Fevereiro 2026 — mandato de 2 anos'
      },
      university: {
        title: 'Parceria acadêmica',
        org: 'Universidade parceira',
        description: 'Convênio de parceria para programas linguísticos, formação profissional e intercâmbios acadêmicos internacionais.',
        date: '2026'
      },
      note: 'Outras colaborações em fase de formalização serão adicionadas aqui.'
    },
    courses: {
      seo_title: 'Cursos',
      seo_description: 'Plataforma e-learning {{companyName}}',
      title: 'Cursos de línguas',
      level: 'Nível',
      hours_price: '{{hours}} horas',
      plan: 'Agendar uma sessão',
      items: {
        fr_business: 'Francês profissional',
        it_business: 'Italiano business',
        en_ngo: 'Inglês para ONGs'
      }
    },
    course_placeholder: {
      seo_title: 'Curso de língua geral',
      seo_description: 'Programa em breve',
      eyebrow: 'Cursos de línguas',
      title: 'Curso de língua geral',
      intro: 'Módulo detalhado em preparação. A equipa {{companyName}} já pode adaptar um percurso de aprendizagem.',
      contact: 'Contacte-nos para uma sessão de avaliação gratuita.',
      cta: 'Falar com um consultor'
    },
    about: {
      seo_title: 'Sobre',
      seo_description: 'Missão e equipa {{companyName}}',
      title: 'Quem somos',
      body: '{{companyName}} apoia organizações africanas e europeias com um hub multilingue. A equipa inclui intérpretes, tradutores, peritos jurídicos, arquitetos de eventos e especialistas de dados.',
      values: {
        impact: { title: 'Impacto', body: 'Simplificamos tarefas administrativas e linguísticas para acelerar projetos.' },
        trust: { title: 'Confiança', body: 'Tratamento seguro de dados, conformidade GDPR e políticas internas rigorosas.' },
        innovation: { title: 'Inovação', body: 'Agente de IA proprietário, automação de workflows e monitorização regulatória.' }
      }
    },
    government_news: {
      title: 'Monitorização regulatória',
      intro: 'Feed automático alimentado pelo agente de IA open-source {{companyName}}.',
      loading: 'A carregar publicações...'
    },
    ai: {
      badge: 'Perguntar à Beaty',
      open_label: 'Abrir assistente Beaty',
      title: 'Beaty · Assistente IA',
      subtitle: 'Suporte administrativo instantâneo',
      empty: 'Pergunte sobre procedimentos, cursos ou orçamentos.',
      loading: 'A analisar...',
      placeholder: 'Pergunta administrativa...',
      send: 'Enviar',
      fallback: 'Não é possível responder agora.',
      disclaimer: '⚠️ Resposta informativa, verifique em fontes oficiais.'
    },
    footer: {
      contacts: 'Contactos',
      address: 'Endereço',
      social: 'Social',
      rights: 'Todos os direitos reservados.',
      legal_updates: 'Atualizações legais',
      faq: 'FAQ',
      privacy: 'Privacidade',
      cookies: 'Cookies',
      terms: 'Termos'
    }
  }
}
